import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const TemplatesContext = createContext(null);

export function TemplatesProvider({ children }) {
  const [templates, setTemplates] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/templates");
      setTemplates(data);
    } catch {
      setTemplates([]);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async ({ name, description, config }) => {
    const { data } = await api.post("/templates", { name, description: description || "", config });
    setTemplates((prev) => [...prev, data]);
    return data;
  };

  const remove = async (template_id) => {
    await api.delete(`/templates/${template_id}`);
    setTemplates((prev) => prev.filter((t) => t.template_id !== template_id));
  };

  return (
    <TemplatesContext.Provider value={{ templates, save, remove, reload: load }}>
      {children}
    </TemplatesContext.Provider>
  );
}

export const useTemplates = () => useContext(TemplatesContext);
